// Base 2 diagnostic questions (12 questions across 5 spheres)
const base2 = [
    // ── I Sfera: Bendroji energija ir savimoka — 3 questions ──
    {
      id: 'q1',
      sphere: 'bendra',
      question: 'Kai jaučiu, kad kažkas aplinkoje yra „ne taip" – nors niekas to garsiai nepasako:',
      choices: {
        a: 'Pasitikiu savo nuojauta ir ramiai stebiu situaciją, kol paaiškėja tikroji priežastis.',
        b: 'Pradedu nerimauti, kad tai susiję su manimi, ir ieškau patvirtinimo, kad viskas gerai.',
        c: 'Fiksuoju pojūtį, bet nesureikšminu – laukiu konkrečių faktų, prieš darydamas išvadas.',
      },
    },
    {
      id: 'q2',
      sphere: 'bendra',
      question: 'Kai tenka priimti sprendimą, kuris gali paveikti artimų žmonių jausmus:',
      choices: {
        a: 'Atvirai ir švelniai išsakau savo poziciją, net jei ji nesutampa su kitų lūkesčiais.',
        b: 'Atidedu sprendimą arba renkuosi tai, kas patinka kitiems, kad tik nekiltų įtampa.',
        c: 'Ieškau kompromiso, kuris atsižvelgtų ir į mano, ir į kitų poreikius vienodai.',
      },
    },
    {
      id: 'q3',
      sphere: 'bendra',
      question: 'Kai jaučiu vidinį emocinį svorį ar svetimą energiją po intensyvaus bendravimo:',
      choices: {
        a: 'Moku sąmoningai atsiriboti ir atkurti savo vidinę ramybę be kitų pagalbos.',
        b: 'Neriu į kito žmogaus bėdas dar giliau, nes jaučiu pareigą padėti, net jei pats kenčiu.',
        c: 'Pripažįstu nuovargį ir trumpam atsitraukiu, kol jausmai nusistovi, ir neieškau priežasčių.',
      },
    },
    // ── II Sfera: Darbas ir karjera — 2 questions ──
    {
      id: 'q4',
      sphere: 'karjera',
      question: 'Kai darbo aplinkoje kyla konfliktas tarp dviejų kolegų ar pusių:',
      choices: {
        a: 'Natūraliai tampu tarpininku – jaučiu, kaip rasti žodžius, kurie sušvelnintų įtampą.',
        b: 'Vengiu bet kokio dalyvavimo, nes bijau, kad būsiu priverstas rinktis pusę ir kam nors neįtiksiu.',
        c: 'Objektyviai išklausau abi puses ir pasiūlau racionalų sprendimą be emocinio įsitraukimo.',
      },
    },
    {
      id: 'q5',
      sphere: 'karjera',
      question: 'Kai komandoje reikia greitai priimti sprendimą, o nuomonės skiriasi:',
      choices: {
        a: 'Jaučiu grupės dinamiką ir intuityviai randu formuluotę, su kuria sutinka dauguma.',
        b: 'Prisitaikau prie garsiau kalbančių ir palaikau bet kurį variantą, kad tik procesas pajudėtų.',
        c: 'Siūlau balsuoti arba išbandyti trumpą kompromisą, kad nė viena pusė neliktų ignoruota.',
      },
    },
    // ── III Sfera: Santykiai ir partnerystė — 2 questions ──
    {
      id: 'q6',
      sphere: 'santykiai',
      question: 'Kai artimas žmogus nuolat peržengia mano asmenines ribas:',
      choices: {
        a: 'Ramiai, bet tvirtai pasakau, kur yra mano riba, ir laikausi jos be kaltės jausmo.',
        b: 'Tyliu ir kenčiu, nes bijau, kad konfrontacija sugadins santykius arba iš vis liksiu vienas.',
        c: 'Bandau švelniai užsiminti apie ribas, bet jei kitas nereaguoja – laikinai atidedu ir prisitaikau prie jo.',
      },
    },
    {
      id: 'q7',
      sphere: 'santykiai',
      question: 'Kai santykiuose jaučiu, kad atiduodu žymiai daugiau nei gaunu:',
      choices: {
        a: 'Sąžiningai įvertinu disbalansą ir pradedu pokalbį apie abipusį indėlį.',
        b: 'Toliau atiduodu viską, tikėdamasis, kad kitas žmogus kada nors pastebės ir įvertins.',
        c: 'Šiek tiek sumažinu savo investiciją ir stebiu, ar santykis natūraliai susibalansuoja.',
      },
    },
    // ── IV Sfera: Finansai ir resursai — 2 questions ──
    {
      id: 'q8',
      sphere: 'finansai',
      question: 'Kai reikia priimti bendrą finansinį sprendimą su partneriu ar šeimos nariu:',
      choices: {
        a: 'Atvirai išsakau savo viziją ir ieškau sprendimo, kuris atitiktų abiejų vertybes.',
        b: 'Nusileidžiu kito nuomonei, nes vengiu konfliktų dėl pinigų ir bijau sugadinti santykius.',
        c: 'Siūlau aiškiai padalinti atsakomybes: bendras biudžetas ir asmeninė laisvė savo daliai.',
      },
    },
    {
      id: 'q9',
      sphere: 'finansai',
      question: 'Kai pasitaiko netikėta finansinė galimybė, bet ji reikalauja greito sprendimo:',
      choices: {
        a: 'Pasitikiu savo intuicija ir veikiu greitai, jei vidinis jausmas sako „taip".',
        b: 'Jei neturiu laiko pasitarti, atsisakau galimybės, nes bijau suklysti.',
        c: 'Greitai įvertinu riziką ir naudą pagal daugelį faktų, ir priimu sprendimą remdamasis savo išvadomis.',
      },
    },
    // ── V Sfera: Savirealizacija ir gyvenimo situacija — 3 questions ──
    {
      id: 'q10',
      sphere: 'savirealizacija',
      question: 'Kai aplinkoje vyrauja chaosas ir nežinomybė:',
      choices: {
        a: 'Tampu ramybės centru kitiems – natūraliai stabilizuoju aplinką savo buvimu.',
        b: 'Absorbuoju aplinkos stresą ir jaučiuosi emociškai paralyžiuotas, negaliu veikti.',
        c: 'Stengiuosi išlikti neutralus ir orientuotis į konkrečius veiksmus, kurie priklauso tik nuo manęs.',
      },
    },
    {
      id: 'q11',
      sphere: 'savirealizacija',
      question: 'Kai jaučiu, kad mano taikus, diplomatiškas charakteris nėra vertinamas aplinkoje:',
      choices: {
        a: 'Lieku ištikimas savo prigimčiai, nes žinau, kad mano stiprybė slypi gebėjime jungti žmones.',
        b: 'Pradedu abejoti savimi ir bandau tapti „griežtesniu" žmogumi, nors tai prieštarauja mano esmei.',
        c: 'Priimu grįžtamąjį ryšį ir ieškau balanso: likti savimi, bet išmokti tvirtesnės komunikacijos.',
      },
    },
    {
      id: 'q12',
      sphere: 'savirealizacija',
      question: 'Kai gyvenimas pateikia situaciją, kurioje turiu rinktis tarp lojalumo kitam ir sąžiningumo sau:',
      choices: {
        a: 'Renkuosi sąžiningumą sau, net jei tai laikinai sukelia įtampą santykiuose.',
        b: 'Paaukoju savo tiesą dėl kito žmogaus ramybės, nes svetimas skausmas man laimės nesuteikia.',
        c: 'Ieškau trečio kelio – būdo pasakyti tiesą taip, kad ji neskaudintų kito, ir aš nesijausčiau išdavęs save.',
      },
    },
  ];

export default base2;
